<template>
  <div class="box1">
    <div class="banner">
      <div class="tag">C生万物 编程之本</div>
      <div class="title">C/C++就业课</div>
    </div>
    <vue-seamless-scroll
      :data="list"
      :class-option="classOption1"
      class="seamless-warp"
    >
      <div class="demo">
        <div class="item" v-for="(item, index) in list" :key="index">
          <p>{{ item.p1 }}</p>
          <p>{{ item.p2 }}</p>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      list: [
        {
          p1: "图形界面开发能力",
          p2: "满足企业级桌面开发需求",
        },
        { p1: "高并发服务器开发能力", p2: "解决大并发量访问问题" },
        { p1: "游戏服务器开发能力", p2: "解决游戏服务器商业化部署问题" },
        { p1: "Windows/Linux跨平台开发能力", p2: "解决金融类数据安全传输问题" },
        {
          p1: "微服务项目开发能力",
          p2: "满足微服务中图像存储、短信验证码生成等需求",
        },
      ],
    };
  },
  computed: {
    classOption1() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
  width: 100%;
  z-index: 3;
  .banner {
    position: relative;
    padding-top: 50px;
    padding-left: 50px;
    width: 100%;
    height: 600px;
    background: url("../../../assets/coursePage/cPuls/banner.png") no-repeat;
    background-size: cover;
    background-position: center;
    box-sizing: border-box;
    .tag {
      width: 259px;
      height: 45px;
      background-image: linear-gradient(223deg, #4ca6ff 0%, #33bbff 100%);
      box-shadow: 0px 10px 20px 0px rgba(119, 187, 255, 0.35);
      border-radius: 24px 20px 20px 0px;
      text-align: center;
      line-height: 45px;
      font-family: PingFang SC;
      font-size: 26px;
      font-weight: normal;
      letter-spacing: 1px;
      color: #ffffff;
    }
    .title {
      margin-top: 10px;
      font-family: PingFangSC-Semibold;
      font-size: 80px;
      letter-spacing: 2px;
      color: #001a33;
      text-shadow: 10px 10px 20px #77bbff;
    }
    .text {
      width: 298px;
      height: 50px;
      background-color: #ffffff;
      box-shadow: 6px 6px 13px 0px rgba(0, 129, 255, 0.55);
      border-radius: 25px;
      border: solid 1px #ffffff;
    }
  }
  .seamless-warp {
    width: 100%;
    overflow: hidden;
    margin-top: -32px;
    padding-bottom: 20px;
    .demo {
      display: flex;
      padding-bottom: 30px;
    }
    .item {
      flex-shrink: 0;
      height: 160px;
      background: linear-gradient(360deg, #ffffff 0%, #dcf3ff 100%);
      box-shadow: 8px 8px 32px 0px rgba(48, 143, 237, 0.2);
      border-radius: 16px;
      border: 2px solid #ffffff;
      margin-right: 32px;
      text-align: left;
      padding-left: 30px;
      box-sizing: border-box;
      p:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 44px;
        margin-top: 32px;
      }
      p:nth-child(2) {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 44px;
        margin-top: 8px;
      }
    }
    .item:nth-child(1) {
      width: 350px;
    }
    .item:nth-child(2) {
      width: 344px;
    }
    .item:nth-child(3) {
      width: 428px;
    }
    .item:nth-child(4) {
      width: 469px;
    }
    .item:nth-child(5) {
      width: 612px;
    }
  }
}
</style>
